import { createFileRoute } from '@tanstack/react-router'
import { MessagesSquareIcon } from 'lucide-react'

export const Route = createFileRoute('/_app/conversas/')({
  component: ConversasEmpty,
})

function ConversasEmpty() {
  return (
    <div className="text-muted-foreground flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
      <MessagesSquareIcon className="size-12 opacity-30" />
      <p className="text-sm">Selecione uma conversa para começar</p>
    </div>
  )
}
